import { StyleDriverStatus } from '../../pages/user/history/style'

const DriveStatus = ({
  status,
  onClick,
}: {
  status: string
  onClick?: () => void
}) => {
  let bg = ''
  let tc = ''

  switch (status) {
    case 'Book Delivered':
      bg = 'green100'
      tc = 'green600'
      break
    case 'Confirm Delivery':
      bg = 'green100'
      tc = 'green600'
      break
    case 'Confirm Pickup':
      bg = 'purple100'
      tc = 'purple600'
      break
    case 'Book PickedUp':
      bg = 'red400'
      tc = 'red600'
      break
    default:
      bg = 'gray'
      tc = 'white'
  }

  return (
    <StyleDriverStatus
      bg={bg}
      tc={tc}
      onClick={() => {
        !!onClick && onClick()
      }}
    >
      {status}
    </StyleDriverStatus>
  )
}

export default DriveStatus
